import * as Yup from "yup";

export const CryptoWalletValidSchema = Yup.object({
  WalletAddress: Yup.string().required("USDTWalletAddress is Required"),
  FXSTRecievingAddress: Yup.string().required(
    "FXSTRecievingaddres is Required"
  ),
  OTP: Yup.string()
    .required("OTP is required")
    .max(6, "OTP must be 6 characters"),
});

export const BankINRvalidSchema = Yup.object({
  IFSC: Yup.string().required("IFSCcode is Required"),
  BankName: Yup.string().required("Bank_Name is Required"),
  BranchName: Yup.string().required("Branch_Name is Required"),
  AccountNo: Yup.string().required("Account_Number is Required"),
  AccountHolderName: Yup.string().required("Account_Holder_Name is Required"),
  // OTP: Yup.string().required('OTP is required').max(6, 'OTP must be 6 characters'),
});

export const BANK_AEDVailSchema = Yup.object({
  AEDAccountHolderName: Yup.string().required(
    "Account_Holder Name  is Required"
  ),
  AEDAccountNumber: Yup.string().required("Account Name  is Required"),
  IBANNumber: Yup.string().required("IBAN is Required"),
  SwiftCode: Yup.string().required("Swift Code is Required"),
  OTP: Yup.string()
    .required("OTP is required")
    .max(6, "OTP must be 6 characters"),
});

export const Cedit_Card_DetailsVailSchema = Yup.object({
  CreditCardHolderMobileNo: Yup.string().required(
    "CreditCard Holder MobileNo is Required"
  ),
  CreditCardNo: Yup.string().required("Credit Card Number is Required"),
  CreditCardHolderName: Yup.string().required(
    "Credit Card Holder Name is Required"
  ),
  OTP: Yup.string().required("OTP is Required"),
});

//================ My Profile form Validation Schema starts Here

export const Personal_DetailsValid_Schema = Yup.object({
  Title: Yup.string().required("Title is Required"),
  FirstName: Yup.string().required("Name is Required"),
  MobileNo: Yup.string()
    .required("Mobile Number is Required")
    .matches(/^\+?\d*$/, "You have Entered Invalid Mobile No"),
  Gender: Yup.string().required("Gender is Required."),
  DateofBirth: Yup.string().required("Date of Birth is Required"),
  FathersName: Yup.string().required("Father's Name is Required."),
  MaritalStatus: Yup.string().required("Marital status is Required."),
  AlternateNo: Yup.string().required("AlternateNo is Required"),
  EmailId: Yup.string()
    .required("Email Id is Required")
    .email("Invalid email format"),
  CountryName: Yup.string().required("Country Name is Required."),
  StateName: Yup.string().required("State Name is Required"),
  CityName: Yup.string().required("City Name is Required"),
  Pincode: Yup.string()
    .required("Pincode is Required.")
    .length(6, "Pincode must be exactly 6 digits")
    .matches(/^[0-9]+$/, "Pincode must be only digits"),
  Address: Yup.string().required("Adddres is Required"),
    // ✅ Strict PAN validation
   PanNumber: Yup.string()
    .required("PAN Number is Required")
    .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number format (e.g., ABCDE1234F)"),
});

export const Nominee_DetailsValid_Schema = Yup.object({
  NomineeName: Yup.string().required("Nominee Name is Required."),
  NomineeRelation: Yup.string().required("Nominee Relation is Required."),
  NomineeDOB: Yup.string().required(" Nominee Date of Birth is Required."),
  NomineeNationalId: Yup.string().optional(),
  NomineeDrivingLicence: Yup.string().optional(),
  NomineePassportNumber: Yup.string().optional(),
});

export const Change_PasswordValid_Schema = Yup.object({
  OldPassword: Yup.string().required("Old Password is Required."),
  NewPassword: Yup.string()
    .required("New Password is required.")
    .min(4, "Password must be at least 4 characters long"),
  ConfirmPassword: Yup.string()
    .oneOf([Yup.ref("NewPassword"), null as any], "Passwords do not match")
    .required("Please confirm your password"),
});

export const SearchFormValid_Schema = Yup.object({
  FromDate: Yup.date().required("From Date is Required."),
  ToDate: Yup.date().required("ToDate is Required."),
});

export const SupportTicketForm = Yup.object({
  QueryString: Yup.string().required("Please Select Type").optional(),
  SearchString: Yup.string().required("Search Field is required").optional(),
  StatusString: Yup.string().required("Select Status Field").optional(),
});

export const RegisterValidSchema = Yup.object().shape({
  SponsorUserName: Yup.string()
    .max(50, "Max 50 characters")
    .required("Required"),
  PIN: Yup.string().max(20, "Max 20 characters").required("Required"),
  FirstName: Yup.string().max(50, "Max 50 characters").required("Required"),
  Gender: Yup.string().required("Gender is Required."),
  MobileNo: Yup.string().max(10, "Max 10 characters").required("Required"),
  EmailId: Yup.string().email("Invalid email").max(100, "Max 100 characters"),
  Password: Yup.string()
    .min(4, "Min 4 characters")
    .max(50, "Max 50 characters")
    .required("Required"),
  ConfirmPassword: Yup.string()
    .oneOf([Yup.ref("Password")], "Passwords must match")
    .required("Required"),
  AcceptTerms: Yup.boolean().oneOf(
    [true],
    "You must accept Terms & Conditions"
  ),
});
